// extracted by mini-css-extract-plugin
export var active = "_kw-2";
export var recordingDot = "_kw-1";
export var recordingIndicator = "_kw-0";